(function() {
    'use strict';

    angular
        .module('ipmApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('coc-agreement-management', {
            parent: 'admin',
            url: '/coc-agreement-management',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_STAFF'],
                pageTitle: 'coc-agreement.home.title.management'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/coc-agreement/coc-agreement-management.html',
                    controller: 'CoCAgreementManagementController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('coc-agreement');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
